import { Component, input } from '@angular/core'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'

import { BaseComponent, Grid } from '../../shared'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { GridColumnGroupComponent } from '../../shared/reusable-components/grid-column-group/grid-column-group.component'
import { GridExportComponent } from '../../shared/reusable-components/grid-export/grid-export.component'
import { GridSelectionCalculationComponent } from '../../shared/reusable-components/grid-selection-calculation/grid-selection-calculation.component'
import { bindPurchasedMaterialTab, PurchasedMaterialFilters, purchasedMaterialScopeKey } from './purchased-material-filters'

interface SimilarMember {
    description: string
    vendor: string
    partNumber: string
    unit: string
    lineCount: number
    medianUnitPrice: number | null
}

interface SimilarGroup {
    representative: string
    reason: string
    confidence: number
    vendorCount: number
    lineCount: number
    spend: number
    unitFamily: string
    lowMedian: number | null
    highMedian: number | null
    priceGap: number | null
    members: SimilarMember[]
}

@Component({
    selector: 'app-purchased-materials-similar',
    templateUrl: './purchased-materials-similar.component.html',
    standalone: true,
    imports: [
        ActionToolbarCount,
        GridExportComponent,
        GridColumnGroupComponent,
        WjGridModule,
        WjGridFilterModule,
        GridSelectionCalculationComponent,
    ],
})
export class PurchasedMaterialsSimilarComponent extends BaseComponent {
    filters = input.required<PurchasedMaterialFilters>()
    active = input(false)

    groupGrid: Grid<SimilarGroup>
    memberGrid: Grid<SimilarMember>
    note = ''

    constructor() {
        super()
        this.groupGrid = new Grid<SimilarGroup>(this.services).wrapColumnHeaders()
        this.memberGrid = new Grid<SimilarMember>(this.services).wrapColumnHeaders()
        bindPurchasedMaterialTab(
            this.filters,
            this.active,
            filters => purchasedMaterialScopeKey(filters, true),
            () => this.clear(),
            filters => this.load(filters),
        )
    }

    showMembers() {
        const group = this.groupGrid.selectedItem as SimilarGroup | null
        this.memberGrid.items = group?.members ?? []
    }

    private clear() {
        this.note = ''
        this.groupGrid.items = []
        this.memberGrid.items = []
    }

    private load(filters: PurchasedMaterialFilters) {
        this.cancelableRequest(
            'similarItems',
            true,
            this.services.data
                .load(true, true, this.services.data.post('/api/PurchasedMaterials/GetSimilarItems', filters))
                .subscribe({
                    next: result => {
                        const payload = result[0]
                        this.note = payload.note ?? ''
                        this.groupGrid.items = payload.groups ?? []
                        this.showMembers()
                    },
                }),
        )
    }
}
